export default class DtoPiezometerMeasure {
    constructor(obj) {
        this.creationDate = obj.creationDate
        this.hour = obj.hour
        this.value = obj.value
    }
}
